import "regenerator-runtime";
import Log from "./logger";
import Auth from "./auth";

import "./assets/almefy.scss?sdk";

document.querySelectorAll('[data-almefy-auth]').forEach((el) => {
    new Auth({
        element: el
    });
});

export {
    Log,
    Auth
}
